<template>
  <el-dialog
    :title="$t('reportCustomGroupManage.add')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form :model="addReportCustomGroupInfo" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item :label="$t('reportCustomGroupManage.groupName')" prop="name">
        <el-input v-model="addReportCustomGroupInfo.name" 
                  :placeholder="$t('reportCustomGroupManage.inputGroupNameRequired')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomGroupManage.groupUrl')" prop="url">
        <el-input v-model="addReportCustomGroupInfo.url" 
                  :placeholder="$t('reportCustomGroupManage.inputGroupUrlRequired')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomGroupManage.description')" prop="remark">
        <el-input type="textarea" v-model="addReportCustomGroupInfo.remark" 
                  :placeholder="$t('reportCustomGroupManage.inputDescriptionRequired')"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveReportCustomGroupInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveReportCustomGroup } from '@/api/dev/reportCustomGroupApi'

export default {
  name: 'AddReportCustomGroup',
  data() {
    return {
      dialogVisible: false,
      addReportCustomGroupInfo: {
        name: '',
        url: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('reportCustomGroupManage.groupNameRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('reportCustomGroupManage.groupNameMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('reportCustomGroupManage.groupUrlRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('reportCustomGroupManage.groupUrlMaxLength'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('reportCustomGroupManage.descriptionRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('reportCustomGroupManage.descriptionMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.addReportCustomGroupInfo = {
        name: '',
        url: '',
        remark: ''
      }
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    saveReportCustomGroupInfo() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return
        
        try {
          await saveReportCustomGroup(this.addReportCustomGroupInfo)
          this.$message.success(this.$t('reportCustomGroupManage.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加报表组失败:', error)
          this.$message.error(error.message || this.$t('reportCustomGroupManage.addFailed'))
        }
      })
    }
  }
}
</script>